import script from "./contactModal.vue?vue&type=script&setup=true&lang=js"
export * from "./contactModal.vue?vue&type=script&setup=true&lang=js"

import "./contactModal.vue?vue&type=style&index=0&id=609ae304&lang=scss&scoped=true"
import "./contactModal.vue?vue&type=style&index=1&id=609ae304&lang=scss"

import exportComponent from "/home/pilki/freelaix/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-609ae304"]])

export default __exports__